import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const getPersonalNotesRequest = () =>
  actionRequestFactory(types.PERSONAL_NOTES_REQUEST, null);
export const getPersonalNotesRequestSuccess = response =>
  actionResponseFactory(types.PERSONAL_NOTES_REQUEST_SUCCESS, response);
export const getPersonalNotesRequestFailure = error =>
  actionResponseFactory(types.PERSONAL_NOTES_REQUEST_FAILURE, { error });

export const putPersonalNotesRequest = payload =>
  actionRequestFactory(types.PERSONAL_NOTES_STORE_PUT, payload);
export const putPersonalNotesRequestSuccess = response =>
  actionResponseFactory(types.PERSONAL_NOTES_STORE_PUT_SUCCESS, response);
export const putPersonalNotesRequestFailure = error =>
  actionResponseFactory(types.PERSONAL_NOTES_STORE_PUT_FAILURE, { error });

export const postPersonalNotesRequest = payload =>
  actionRequestFactory(types.PERSONAL_NOTES_STORE_POST, payload);
export const postPersonalNotesRequestSuccess = response =>
  actionResponseFactory(types.PERSONAL_NOTES_STORE_POST_SUCCESS, response);
export const postPersonalNotesRequestFailure = error =>
  actionResponseFactory(types.PERSONAL_NOTES_STORE_POST_FAILURE, { error });

export const getFilingNotesRequest = payload =>
  actionRequestFactory(types.FILING_NOTES_REQUEST, payload);
export const getFilingNotesRequestSuccess = response =>
  actionResponseFactory(types.FILING_NOTES_REQUEST_SUCCESS, response);
export const getFilingNotesRequestFailure = error =>
  actionResponseFactory(types.FILING_NOTES_REQUEST_FAILURE, { error });

export const putFilingNotesRequest = payload =>
  actionRequestFactory(types.FILING_NOTES_STORE_PUT, payload);
export const putFilingNotesRequestSuccess = response =>
  actionResponseFactory(types.FILING_NOTES_STORE_PUT_SUCCESS, response);
export const putFilingNotesRequestFailure = error =>
  actionResponseFactory(types.FILING_NOTES_STORE_PUT_FAILURE, { error });

export const postFilingNotesRequest = payload =>
  actionRequestFactory(types.FILING_NOTES_STORE_POST, payload);
export const postFilingNotesRequestSuccess = response =>
  actionResponseFactory(types.FILING_NOTES_STORE_POST_SUCCESS, response);
export const postFilingNotesRequestFailure = error =>
  actionResponseFactory(types.FILING_NOTES_STORE_POST_FAILURE, { error });
